(function () {
  'use strict';

  /* ── Elements ── */
  const modal    = document.getElementById('mt-lcl-modal');
  const backdrop = document.getElementById('mt-lcl-backdrop');
  const closeBtn = document.getElementById('mt-lcl-close');
  const trigger  = document.querySelector('.mt-util__locale');
  const countrySel = document.getElementById('mt-lcl-country');
  const currencySel = document.getElementById('mt-lcl-currency');
  const summaryText = document.getElementById('mt-lcl-summary-text');

  if (!modal) return;

  /* ── Wrap inner content in .mt-lcl-inner card ──
     The snippet renders content nodes directly inside the dialog.
     Wrapping them in a card element lets the CSS center and animate
     the box without nesting everything inside a fixed inner div in
     the Liquid (which would put the close button outside the card). */
  const inner = document.createElement('div');
  inner.className = 'mt-lcl-inner';
  Array.from(modal.children).forEach((child) => {
    if (!child.classList.contains('mt-lcl-close')) {
      inner.appendChild(child);
    }
  });
  modal.appendChild(inner);

  /* ── Open / close ── */
  function openModal() {
    modal.removeAttribute('aria-hidden');
    backdrop.removeAttribute('aria-hidden');
    modal.setAttribute('aria-hidden', 'false');
    backdrop.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(() => {
      modal.classList.add('is-open');
      backdrop.classList.add('is-open');
    });

    document.body.style.overflow = 'hidden';
    /* focus the first select after transition */
    setTimeout(() => {
      if (countrySel) countrySel.focus();
    }, 320);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (trigger) trigger.focus();
  }

  /* ── Wire trigger ── */
  if (trigger) {
    trigger.addEventListener('click', openModal);
  }
  /* also allow mtLocaleOpen() to be called from mobile drawer or elsewhere */
  window.mtLocaleOpen = openModal;

  closeBtn && closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);

  modal.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });

  /* ── Currency display follows country selection ── */
  if (countrySel && currencySel) {
    countrySel.addEventListener('change', () => {
      const opt = countrySel.options[countrySel.selectedIndex];
      const code = opt ? opt.dataset.currency : '';
      const sym  = opt ? opt.dataset.symbol  : '';

      /* update the disabled currency select to show the correct option */
      for (let i = 0; i < currencySel.options.length; i++) {
        if (currencySel.options[i].value === code) {
          currencySel.selectedIndex = i;
          break;
        }
      }

      /* live-update the summary line */
      if (summaryText) {
        const country = opt ? opt.textContent.trim() : '';
        const langEl  = document.getElementById('mt-lcl-lang');
        const lang    = langEl
          ? langEl.options[langEl.selectedIndex]?.value?.toUpperCase()
          : summaryText.textContent.split('·').pop().trim();
        summaryText.textContent =
          country + ' · ' + sym + code + ' · ' + lang;
      }
    });
  }

  /* ── Focus trap ── */
  modal.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const focusable = Array.from(
      modal.querySelectorAll(
        'button:not([disabled]), select:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !el.closest('[aria-hidden="true"]'));
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });
})();
